<template>
  <MainLayout>
    <template #toolbar>
      <Shortcuts
        :main-shortcut="''"
        :shortcuts="['budget','create_advertiser','create_campaign']"
      />
    </template>
    <div class="d-flex align-items-center justify-content-center mt-5 mb-10">
      <BaseIcon size="small">
        <FinanceIcon />
      </BaseIcon>
      <h1 class="text-uppercase mb-0 ms-5">{{ $t('financial') }}</h1>
    </div>
    <div class="d-flex justify-content-end align-items-center mb-5">
      <div class="col-12">
        <CreateOrderButton
          v-if="user"
          :reloadAdvertisers="reloadAdvertisers"
          @order-created="handleOrderCreated"
        />
      </div>
    </div>
    <div class="text-center mt-4" v-if="loader && !user">
      <Loader
        :size="'big'"
      />
    </div>
    <div class="mt-4" v-else>
      <b-tabs content-class="mt-4" nav-class="default-tabs">
        <!-- EXTRATO TAB -->
        <b-tab :title="$t('my_wallet')" v-if="
          user &&
          user.company.type === 'AGENCY' &&
          walletsSummary &&
          (walletsSummary.amount_available_for_payment > 0 || walletsSummary.amount_frozen > 0)
        ">
          <!-- AVAILABLE -->
          <section class="mb-5" v-if="walletsSummary">
            <div class="col-md-10 mx-auto p-3 mb-5">
              <div class="notice d-flex bg-light-warning border-warning border border-dashed p-6">
                <!--begin::Icon-->
                <span class="svg-icon svg-icon-2tx svg-icon-primary me-4">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 19.725V18.725C20 18.125 19.6 17.725 19 17.725H5C4.4 17.725 4 18.125 4 18.725V19.725H3C2.4 19.725 2 20.125 2 20.725V21.725H22V20.725C22 20.125 21.6 19.725 21 19.725H20Z" fill="currentColor"></path>
                    <path opacity="0.3" d="M22 6.725V7.725C22 8.325 21.6 8.725 21 8.725H18C18.6 8.725 19 9.125 19 9.725C19 10.325 18.6 10.725 18 10.725V15.725C18.6 15.725 19 16.125 19 16.725V17.725H15V16.725C15 16.125 15.4 15.725 16 15.725V10.725C15.4 10.725 15 10.325 15 9.725C15 9.125 15.4 8.725 16 8.725H13C13.6 8.725 14 9.125 14 9.725C14 10.325 13.6 10.725 13 10.725V15.725C13.6 15.725 14 16.125 14 16.725V17.725H10V16.725C10 16.125 10.4 15.725 11 15.725V10.725C10.4 10.725 10 10.325 10 9.725C10 9.125 10.4 8.725 11 8.725H8C8.6 8.725 9 9.125 9 9.725C9 10.325 8.6 10.725 8 10.725V15.725C8.6 15.725 9 16.125 9 16.725V17.725H5V16.725C5 16.125 5.4 15.725 6 15.725V10.725C5.4 10.725 5 10.325 5 9.725C5 9.125 5.4 8.725 6 8.725H3C2.4 8.725 2 8.325 2 7.725V6.725L11 2.225C11.6 1.925 12.4 1.925 13.1 2.225L22 6.725ZM12 3.725C11.2 3.725 10.5 4.425 10.5 5.225C10.5 6.025 11.2 6.725 12 6.725C12.8 6.725 13.5 6.025 13.5 5.225C13.5 4.425 12.8 3.725 12 3.725Z" fill="currentColor"></path>
                  </svg>
                </span>
                <!--end::Icon-->
                <!--begin::Content-->
                <div class="mb-3 mb-md-0 fw-semibold col-9">
                  <div class="fs-6 text-gray-700 pe-7" v-html="$t('info_withdrawal')"></div>
                </div>
                <!--end::Content-->
                <!--begin::Action-->
                <Button
                  class="btn-color9"
                  :disabled="walletsSummary.amount_available_for_payment <= 0"
                  @click="walletCheckoutOpen = !walletCheckoutOpen"
                >
                  {{ $t('make_withdrawal') }}
                </Button>
                <!--end::Action-->
              </div>
              <div class="d-flex flex-row justify-content-center align-items-center gap-5">
                <div class="card card-dashed border-color10 flex-center min-w-175px my-3 p-4">
                  <span class="fs-4 fw-semibold text-color10 pb-1 px-2">{{ $t('available_balance') }}</span>
                  <span class="fs-lg-1 fw-bold d-flex justify-content-center">
                  <span data-kt-countup="true" :data-kt-countup-value="walletsSummary.amount_available_for_payment/100" class="counted" data-kt-initialized="1">{{ walletsSummary.amount_available_for_payment/100 | formatMoney }}</span></span>
                </div>
                <div class="card card-dashed border-color10 flex-center min-w-175px my-3 p-4">
                  <span class="fs-4 fw-semibold text-color10 pb-1 px-2">{{ $t('balance_receivable') }}</span>
                  <span class="fs-lg-1 fw-bold d-flex justify-content-center">
                  <span data-kt-countup="true" :data-kt-countup-value="walletsSummary.amount_frozen/100" class="counted" data-kt-initialized="1">{{ walletsSummary.amount_frozen/100 | formatMoney }}</span></span>
                </div>
              </div>
            </div>
            <CreateWalletCheckout
              v-if="walletCheckoutOpen"
              @wallet-checkout-created="getWallets"
            />
          </section><!-- END AVAILABLE -->
          <!-- FILTER -->
          <section class="mb-4">
            <div class="d-flex align-items-center justify-content-center">
              <div class="d-flex text-center align-items-center justify-content-center font-size-small default-form me-3">
                {{ $t('filter_from') }}
                <DateTimeInput
                  v-model.trim="walletStart"
                  format="dd/MM/yyyy"
                  type="date"
                  theme="basic"
                  class="mx-2 form-control-sm-wrapper"
                />
                {{ $t('to') }}
                <DateTimeInput
                  v-model.trim="walletEnd"
                  format="dd/MM/yyyy"
                  type="date"
                  theme="basic"
                  class="mx-2 form-control-sm-wrapper"
                />
              </div>
              <div>
                <Button
                  class="btn-color9 btn-xs"
                  @click="resetWallets"
                >
                  {{ $t('search') }}
                </Button>
              </div>
            </div>
          </section> <!-- END FILTER -->
          <!-- CONTENT -->
          <section>
            <div class="text-center" v-if="walletsLoader && wallets.length === 0">
              <Loader
                :size="'big'"
              />
            </div>
            <div class="" v-else>
              <div v-if="wallets.length === 0">
                <p class="text-center">{{ $t('no_transactions_found') }}</p>
              </div>
              <div v-else>
                <div class="card">
                  <div class="card-body">
                    <div class="mb-4">
                      <p>
                        <strong>{{ $t('credit_amount') }}:</strong> {{ walletsSummary.credit_amount / 100 | formatMoney }}<br/>
                        <strong>{{ $t('debit_amount') }}:</strong> {{ walletsSummary.debit_amount / 100 | formatMoney }}
                      </p>
                    </div>
                    <b-tabs content-class="mt-4" nav-class="default-tabs">
                      <!-- HISTORY TAB -->
                      <b-tab :title="$t('history')">
                        <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
                          <thead>
                            <tr>
                              <th>{{ $t('date') }}</th>
                              <th>{{ $t('description') }}</th>
                              <th>{{ $t('total') }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(wallet, index) in pastWallets" :key="index">
                              <td>{{ wallet.payment_date | formatDate }}</td>
                              <td>{{ wallet.description }}</td>
                              <td>
                                {{ wallet.type | formatWalletTypeToSignal }}
                                {{ wallet.amount / 100 | formatMoney }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </b-tab> <!-- END HISTORY TAB -->
                      <!-- FUTURE HISTORY TAB -->
                      <b-tab title="Lançamentos futuros">
                        <table class="table table-striped">
                          <thead>
                            <tr>
                              <th>{{ $t('date') }}</th>
                              <th>{{ $t('description') }}</th>
                              <th>{{ $t('total') }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(wallet, index) in futureWallets" :key="index">
                              <td>{{ wallet.payment_date | formatDate }}</td>
                              <td>{{ wallet.description }}</td>
                              <td>
                                {{ wallet.type | formatWalletTypeToSignal }}
                                {{ wallet.amount / 100 | formatMoney }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </b-tab> <!-- END FUTURE HISTORY TAB -->
                    </b-tabs>
                  </div>
                </div>
                <div class="text-center mt-4">
                  <Button
                    class="btn-color9"
                    :loading="walletsLoader"
                    @click="loadMoreWallets"
                    v-if="isLoadMoreWalletsVisible"
                  >
                    {{ $t('load_more') }}
                  </Button>
                </div>
              </div>
            </div>
          </section><!-- END CONTENT -->
        </b-tab> <!-- END EXTRATO TAB -->
        <!-- BANK ACCOUNT TAB -->
        <b-tab :title="$t('receiving_account')" v-if="
          user &&
          user.company.type === 'AGENCY' &&
          walletsSummary &&
          (walletsSummary.amount_available_for_payment > 0 || walletsSummary.amount_frozen > 0)
        ">
          <div class="text-center" v-if="accountLoader">
            <Loader
              :size="'big'"
            />
          </div>
          <div class="" v-else>
            <p class="text-center"><strong>{{ $t('info_bank_account') }}</strong></p>
            <div v-if="account" class="d-flex justify-content-center">
              <BankAccountCard
                :account="account"
              />
            </div>
            <div v-else>
              <p class="text-center">{{ $t('no_accounts_found') }}</p>
            </div>
            <div class="text-center mt-4">
              <Button
                class="btn btn-color9"
                @click="bankAccountOpen = !bankAccountOpen"
              >
                {{ account ? $t('change_bank_account') : $t('create_bank_account') }}
              </Button>
              <CreateBankAccount
                v-if="bankAccountOpen"
                @created-bank-account="getBankAccount"
              />
            </div>
          </div>
        </b-tab> <!-- END BANK ACCOUNT TAB -->
        <!-- PAYMENTS TAB -->
        <b-tab :title="$t('fund_movements')">
          <div>
            <OrderListTable
              :reload="reloadOrders"
            />
          </div>
        </b-tab> <!-- END PAYMENTS TAB -->
      </b-tabs>
    </div>
  </MainLayout>
</template>

<script>

import BankAccountsService from '@/modules/bank-accounts/services/bank-accounts-service'
import { mapState } from 'vuex'
import moment from 'moment'
import variables from '@/mixins/variables'
import WalletsService from '@/modules/wallets/services/wallets-service'

import BankAccountCard from '@/components/bank-accounts/BankAccountCard'
import BaseIcon from '@/components/common/Icon/BaseIcon'
import Button from '@/components/common/Button/Button'
import CreateBankAccount from '@/components/bank-accounts/CreateBankAccount'
import CreateOrderButton from '@/components/orders/CreateOrderButton'
import CreateWalletCheckout from '@/components/wallets/CreateWalletCheckout'
import DateTimeInput from '@/components/common/Input/DateTimeInput'
import FinanceIcon from '@/components/common/Icon/FinanceIcon'
import Loader from '@/components/common/Loader/Loader'
import MainLayout from '@/components/layouts/MainLayout'
import OrderListTable from '@/components/orders/OrderListTable'
import Shortcuts from '@/components/common/Shortcuts/Shortcuts'

export default {
  mixins: [variables],
  components: {
    BankAccountCard,
    BaseIcon,
    Button,
    CreateBankAccount,
    CreateOrderButton,
    CreateWalletCheckout,
    DateTimeInput,
    FinanceIcon,
    Loader,
    MainLayout,
    OrderListTable,
    Shortcuts
  },
  data () {
    return {
      account: null,
      accountLoader: false,
      bankAccountOpen: false,
      isLoadMoreWalletsVisible: false,
      loader: true,
      reloadAdvertisers: false,
      reloadOrders: false,
      tabIndex: 0,
      wallets: [],
      walletsSummary: null,
      walletsLoader: false,
      walletStart: '',
      walletEnd: '',
      walletsPage: 1,
      walletCheckoutOpen: false
    }
  },
  metaInfo () {
    return {
      title: this.$t('financial')
    }
  },
  created () {
    this.walletStart = moment({ hour: 0, minute: 0, seconds: 0 }).subtract(60, 'days').format()
    this.walletEnd = moment({ hour: 0, minute: 0, seconds: 0 }).add(60, 'days').format()
    if (this.user) {
      this.checkIfUserIsManager()
      this.getContent()
    }
  },
  watch: {
    user (newUser) {
      this.checkIfUserIsManager()
      this.getContent()
    }
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    }),
    /**
     * Future wallets entries
     */
    futureWallets () {
      const now = moment()
      return this.wallets.filter(item => {
        const date = moment(item.payment_date)
        return date.isAfter(now)
      })
    },
    /**
     * Past wallets entries
     */
    pastWallets () {
      const now = moment()
      return this.wallets.filter(item => {
        const date = moment(item.payment_date)
        return date.isSameOrBefore(now)
      })
    }
  },
  methods: {
    /**
     * Check if user is manager or not
     */
    checkIfUserIsManager () {
      if (this.user.role.slug !== 'user-manager' && this.user.role.slug !== 'administrator') this.$router.push('/')
    },
    /**
     * Get main bank account
     */
    async getBankAccount () {
      this.accountLoader = true
      this.bankAccountOpen = false
      try {
        const account = await BankAccountsService.getPrimaryBankAccount({ companyId: this.user.company.id })
        this.account = account
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.accountLoader = false
    },
    /**
     * Get page content
     */
    getContent () {
      // Set active tab depending on type of company
      if (this.user.company.type !== 'AGENCY') this.tabIndex = 2
      this.getWallets()
      this.getBankAccount()
    },
    /**
     * Get wallets
     */
    async getWallets () {
      this.walletsLoader = true
      this.walletCheckoutOpen = false
      try {
        const wallets = await WalletsService.getWallets({
          start_date: moment(this.walletStart).format('YYYY-MM-DD'),
          end_date: moment(this.walletEnd).format('YYYY-MM-DD'),
          companyId: this.user.company.id,
          page: this.walletsPage
        })
        this.wallets = [...this.wallets, ...wallets.data]
        this.isLoadMoreWalletsVisible = wallets.meta.current_page !== wallets.meta.last_page
        this.walletsSummary = wallets.additional_info
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.walletsLoader = false
    },
    /**
     * Load more orders
     */
    loadMoreWallets () {
      this.walletsPage++
      this.getWallets()
    },
    /**
     * Reload orders
     */
    handleOrderCreated () {
      this.orders = []
      this.reloadOrders = true
      setTimeout(() => {
        this.reloadOrders = false
      }, 700)
    },
    resetWallets () {
      this.wallets = []
      this.walletsPage = 1
      this.getWallets()
    }
  }
}
</script>
